import { api } from "../../utils/api";

export async function postDoc(doc) {
  try {
    const response = await api.post("user-roles", { doc });
    return response.data;
  } catch (error) {
    return error.data;
  }
}


